<template>
  <DataList
    title="Типи Сервісів"
    resource="service-types"
    :columns="columns"
    :get-items-fn="getServiceTypes"
    :search-label="'Пошук за назвою типу сервіса'"
  />
</template>

<script>
import * as serviceTypesApi from "../../../backend/serviceTypesApi.js";

export default {
  data: () => ({
    columns: [
      { title: "id", name: "id" },
      { title: "Найменування", name: "title" },
    ],
  }),
  methods: {
    getServiceTypes(...args) {
      return serviceTypesApi.getServiceTypes(
        args[0],
        args[1],
        args[2],
        args[3]
      );
    },
  },
};
</script>
